var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"width":_vm.width,"height":_vm.height,"alt":_vm.altText,"src":_vm.processedSrc},on:{"error":function($event){_vm.isErrored = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }